window.addEventListener(
  'message',
  function (event) {
    if (event.origin === 'https://exemplis.formtitan.com') {
      try {
        var data = JSON.parse(event.data);
        if (data.close_modal === 'true') {
          modal.style.display = 'none';
          document.body.classList.remove('body-no-scroll');
          var modalShortcode = document.querySelector('.modal__info-form__inner-shortcode');
          var innerHTML = modalShortcode.innerHTML;
          modalShortcode.innerHTML = innerHTML;
        }
      } catch (e) {
        console.log('Error parsing message data:', e);
      }
    }
  },
  false
);